import { setHeaders } from "../../utils/fetch";

const getters = {
  spaces: state => state.spaces,
  selectedSpace: state => state.selectedSpace
};

const actions = {
  createSpace(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/space`, {
        method: "post",
        headers: setHeaders(
          {
            "Content-Type": "application/json"
          },
          context.getters.user
        ),
        body: JSON.stringify(data)
      })
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("addSpace", data);
          resolve(data);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  updateSpace(context, data) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/space/${
          data.spaceId
        }`,
        {
          method: "put",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          ),
          body: JSON.stringify(data)
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setSpace", data);
          resolve(data);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  deleteSpace(context, data) {
    return new Promise((resolve, reject) => {
      fetch(`${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/space`, {
        method: "delete",
        headers: setHeaders(
          {
            "Content-Type": "application/json"
          },
          context.getters.user
        ),
        body: JSON.stringify(data)
      })
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setSpaces", data);
          resolve(data);
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  },
  loadSpaces(context, tenant) {
    return new Promise((resolve, reject) => {
      fetch(
        `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/space/${tenant}`,
        {
          method: "get",
          headers: setHeaders(
            {
              "Content-Type": "application/json"
            },
            context.getters.user
          )
        }
      )
        .then(res => {
          return res.json();
        })
        .then(function(data) {
          context.commit("setSpaces", data);

          // data[1].showEdit = true;

          // for (let index = 0; index < 50; index++) {
          //   data.push(data[0]);
          // }

          resolve(
            context.state.selectedSpace ||
              data[0] || {
                id: "all"
              }
          );
        })
        .catch(e => {
          context.commit("setSpaces", []);
          window.console.error(e);
          reject();
        });
    });
  }
};

const mutations = {
  setSpace(state, space) {
    state.selectedSpace = space;
  },
  setSpaces(state, spaces) {
    spaces.map(space => {
      space.showEdit = space.showEdit || false;
    });

    state.spaces = spaces.sort(function(x, y) {
      return x.spaceId == "all" ? -1 : y.spaceId == "all" ? 1 : 0;
    });

    const space = spaces.find(space => {
      return space.id === state.selectedSpace.id;
    });

    if (spaces.length === 1 || !space) {
      state.selectedSpace = spaces[0];
    }
  },
  addSpace(state, spaces) {
    state.spaces.push(spaces);
  }
};

export default {
  state: initializeState(),
  mutations,
  actions,
  getters
};

function initializeState() {
  return {
    spaces: [],
    selectedSpace: {
      spaceId: "all",
      tenantEditable: false
    }
  };
}
